import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { Suspense, lazy } from "react";

const About                     = lazy(() => import("../components/About/index.jsx"));
const BenefitsOfEV              = lazy(() => import("../components/Homepage/PluxElectricMedia/BenefitOfEV/index.jsx"));
const Contact                   = lazy(() => import("../components/Contact/index.jsx"));
const Error                     = lazy(() => import("../components/Error/Error.jsx"));
const EvChargerInstalltion      = lazy(() => import("../components/FeaturedServices/EvChargerInstallation/index.jsx"));
const EVLeasingAndRenting       = lazy(() => import("../components/Homepage/PluxElectricMedia/EVLeasingAndRenting/index.jsx"));
const EVRoadSideAssistance      = lazy(() => import("../components/FeaturedServices/EvRoadsideAssitance/index.jsx"));
const FutureOfEV                = lazy(() => import("../components/Homepage/PluxElectricMedia/FutureOfEV/index.jsx"));
const Home                      = lazy(() => import("../components/Homepage/index.jsx"));
const Layout                    = lazy(() => import("../components/sharedComponent/Layout"));
const Loader                    = lazy(() => import("../components/sharedComponent/Loader/Loader.jsx"));
const Mobility                  = lazy(() => import("../components/FeaturedServices/Mobility/index.jsx"));
// const Login                     = lazy(() => import("../components/Login/Login.jsx"));
const PickAndDropOff            = lazy(() => import("../components/FeaturedServices/PickAndDropOff/index.jsx"));
// const PickAndDropOffBook        = lazy(() => import("../components/FeaturedServices/PickupAndDropOffBook/index.jsx"));
const PlusXForBusiness          = lazy(() => import("../components/PlusxBusiness/index.jsx"));
const PrivacyPolicy             = lazy(() => import("../components/PrivacyPolicy/index.jsx"));
const PublicCharging            = lazy(() => import("../components/FeaturedServices/PublicCharging/index.jsx"));
const Sustainability            = lazy(() => import("../components/Sustainability/index.jsx"));
const TermsAndCondition         = lazy(() => import("../components/TermsAndCondition/index.jsx"));
// const PortableChargerBook       = lazy(() => import("../components/FeaturedServices/PortableChargerBook/index.jsx"));
const PortablePowerChargingPod  = lazy(() => import("../components/FeaturedServices/PortablePowerChargingPod/index.jsx"));
const RiseOfEV                  = lazy(() => import("../components/Homepage/PluxElectricMedia/RiseOfEV/index.jsx"));

const router = createBrowserRouter([
  {
    path        : "/",
    Component   : Layout,
    children    : [
      {
        index   : true,
        element : <Home />,
      },
      // {
      //   path   : "/login",
      //   element : <Login />,
      // },
      {
        path    : "/about-us",
        element : <About />,
      },
      {
        path    : "/contact-us",
        element : <Contact />,
      },
      {
        path    : "/commercial-ev-charging-solutions",
        element : <PlusXForBusiness />,
      },
      {
        path    : "/mobility-solution",
        element : <Mobility />,
      },
      {
        path    : "/sustainability",
        element : <Sustainability />,
      },
      {
        path    : "/privacy-policy",
        element : <PrivacyPolicy />,
      },
      {
        path    : "/terms-and-conditions",
        element : <TermsAndCondition />,
      },
      {
        path    : "/doorstep-ev-charging",
        element : <PortablePowerChargingPod />,
      },
      // {
      //   path    : "/doorstep-ev-charging-book",
      //   element : <PortableChargerBook />,
      // },
      {
        path    : "/ev-pickup-dropoff-charging-service",
        element : <PickAndDropOff />,
      },
      // {
      //   path    : "/ev-pickup-dropoff-charging-service-book",
      //   element : <PickAndDropOffBook />,
      // },
      {
        path    : "/public-ev-charging-stations",
        element : <PublicCharging />,
      },
      {
        path    : "/ev-chargers",
        element : <EvChargerInstalltion />,
      },
      {
        path    : "/ev-roadside-assistance-service",
        element : <EVRoadSideAssistance />,
      },
      {
        path    : "/exploring-the-benefits-of-electric-vehicles-in-the-uae-a-comprehensive-guide",
        element : <BenefitsOfEV />,
      },
      {
        path    : "/the-rise-of-electric-vehicles-in-the-uae-a-comprehensive-overview",
        element : <RiseOfEV />,
      },
      {
        path    : "/electric-vehicle-leasing-and-renting-options-in-the-uae",
        element : <EVLeasingAndRenting />,
      },
      {
        path    : "/the-future-of-electric-mobility-innovations-and-trends-in-the-uae",
        element : <FutureOfEV />,
      },

      // Old Url Mapping...
      {
        path: "/portable-power-pods",
        element: <Navigate to="/doorstep-ev-charging" replace />,
      },
      {
        path: "/pickup-and-dropoff",
        element: <Navigate to="/ev-pickup-dropoff-charging-service" replace />,
      },
      {
        path: "/plusx-for-business",
        element: <Navigate to="/commercial-ev-charging-solutions" replace />,
      },

      //accept all undefined routes
      {
        path    : "*",
        element : <Error />,
      },
    ],
  },
]);

function Router() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
    </>
  );
}

export default Router;
